import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * English count-word: `pluralize(1, 'item') === 'item'`, `pluralize(3, 'item')
 * === 'items'`. Pass the third arg for irregular plurals. Just the noun — copy
 * whose verb/pronoun also agrees is clearer written out inline.
 */
export function pluralize(count: number, singular: string, plural = `${singular}s`): string {
  return count === 1 ? singular : plural;
}

/**
 * Epoch ms → "26 Jul, 02:15 pm" for the board card and lead detail. The year is
 * added only when the stamp is not from the current year, so the common case
 * (this show) stays short on a phone card.
 */
export function formatTimestamp(epochMs: number): string {
  const date = new Date(epochMs);
  const includeYear = date.getFullYear() !== new Date().getFullYear();
  return date.toLocaleString('en-IN', {
    day: 'numeric',
    month: 'short',
    ...(includeYear ? { year: 'numeric' } : {}),
    hour: '2-digit',
    minute: '2-digit'
  });
}
